import { render } from "./PersonDecider.vue?vue&type=template&id=21a18273"
import script from "./PersonDecider.vue?vue&type=script&lang=js"
export * from "./PersonDecider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__